<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'Organizations' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Organizations
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Organizations</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <!-- Default box -->
        <div class="card" id="organizations">
          <div class="card-header py-3">
            <h3 class="card-title">Detail</h3>
          </div>

          <div class="overlay" v-if="isLoading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <div class="card-body">
            <div class="custom-list">
              <ul>
                <li><strong>Name</strong>{{ organization.org_name }}</li>
                <li>
                  <strong>Organization Logo</strong
                  ><img
                    v-if="organization.org_logo"
                    v-bind:src="showLogo"
                    class="img-thumbnail"
                  />
                </li>
                <li>
                  <strong>Created At</strong
                  >{{
                    !_.isEmpty(organization.created_at)
                      ? organization.created_at
                      : ""
                  }}
                </li>
                <li>
                  <strong>Updated At</strong
                  >{{
                    !_.isEmpty(organization.updated_at)
                      ? organization.updated_at
                      : ""
                  }}
                </li>
              </ul>
            </div>
          </div>
          <!-- /.card-body -->
          <div class="card-footer"></div>
          <!-- /.card-footer-->
        </div>
        <!-- /.card -->
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import { OrganizationsAPI } from "@/services/api";

export default {
  name: "OrganizationView",
  metaInfo: {
    title: "Organization | Dotlines",
  },
  // components: {
  //   DatePicker
  // },
  data: () => ({
    params: {},
    organization: {},
    isLoading: false,
    showLogo: "",
  }),
  mounted: function () {
    this.getOrganizationDetail(this.$route.params.id);
    // let _this = this;
    // _this.param = _this.$route.params;
    // _this.getUserDetail(_this.param.id);
    // this.api_url = '/organizations';
    // _this.getOrganizationDetail(_this.param.id);
    // this.getOrganization();
    // console.log('env::', this.API_BASE_URL);
  },
  methods: {
    // getOrganizationDetail: function (id) {
    //   // let token = sessionStorage.getItem("token");
    //   // const AuthStr = 'Bearer '.concat(token);
    //   // let api_url = api_base_url + '/organizations/'+id;
    //   // let _this = this;
    //   // _this.isLoading = true;
    //
    //   let api_url = '/organizations/' + id;
    //   let _this = this;
    //   _this.is_loading = true;
    //
    //   axios.get(api_url)
    //     .then(response => {
    //       //console.log('response.data::', response.data);
    //       _this.organization = response.data;
    //       _this.asset_get_url = process.env.VUE_APP_ASSET_UPLOAD_URL;
    //       _this.showLogo = _this.asset_get_url + '/' + _this.organization.org_logo;
    //       _this.isLoading = false;
    //     })
    //     .catch((error) => {
    //       console.log('error ' + error);
    //     });
    // }

    getOrganizationDetail(id) {
      OrganizationsAPI.show(id).then((organization) => {
        this.organization = organization;
        this.asset_get_url = this.API_ASSET_UPLOAD_URL;
        this.showLogo = this.asset_get_url + "/" + this.organization.org_logo;
        this.isLoading = false;
      });
    },
  },
};
</script>
